import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import Status from '../Helper/Status'
import AbstractEntity from '../Entity/AbstractEntity'

/**
* Class DateDeclenchementAlerte
* DateDeclenchementAlerte view component
**/
class DateDeclenchementAlerte extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Alerte";
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading object if it doesn't exist
  **/
  componentWillMount() {

    if(this.state.object === undefined) {
      const pathName = this.getObjectPath();

      rest({method: 'GET', path: REST_API_URL + pathName}).then(response => {
        let state = this.state;
        let obj = JSON.parse(response.entity);

        obj.dateDeclenchement = getDateFromString(obj.dateDeclenchement);
        state.object = obj;

        this.setState(state)
      });
    }
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return <div></div>;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateDeclenchement = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateDeclenchement) {

        dateDeclenchement = this.state.object.dateDeclenchement;

        if(typeof dateDeclenchement === "string") {
          dateDeclenchement = getDateFromString(dateDeclenchement);
        }

        dateDeclenchement = getIsoStringFromDate(dateDeclenchement);
      }
    }

    const minDate = getIsoStringFromDate(new Date());
    const backToAlerte = <Button bsStyle="link" onClick={this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {backToAlerte}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de date d'alerte.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idDatesAlerte" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idDatesAlerte")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="dateDeclenchement">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Date de déclenchement</ControlLabel></Col>
            <Col sm={2}><DatePicker minDate={minDate} dateFormat="DD/MM/YYYY" value={dateDeclenchement} onChange={this.handleDateDeclenchementChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={8} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idDatesAlerte";
  }

  /**
  * handleDateDeclenchementChange
  * Modify the state dateDebut property from dateDebut field change
  **/
  handleDateDeclenchementChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateDeclenchement"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    const dateDeclenchementAlerteObj = cloneObject(this.state.object);
    let state = this.state;

    if(!dateDeclenchementAlerteObj.dateDeclenchement) {
      state.status = {
        type: 'danger',
        message: 'Le champ Date de déclenchement est obligatoire.'
      };
      this.setState(state);
      return;
    }

    if(dateDeclenchementAlerteObj.dateDeclenchement !== "string") {
      dateDeclenchementAlerteObj.dateDeclenchement = getStringFromDate(dateDeclenchementAlerteObj.dateDeclenchement);
    }

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(dateDeclenchementAlerteObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Date de déclenchement  sauvegardée.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);

        const state = {
          status: {
            type: 'success',
            message: 'Date de déclenchement créée.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/datedeclenchementalertes/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default DateDeclenchementAlerte;



// WEBPACK FOOTER //
// ./src/views/Entity/DateDeclenchementAlerte.js